exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\r\n    background-color: #F0F0F0;\r\n    display: block;\r\n    /* height: 100px; */\r\n}\r\n.assign-drvr-popup-wrapper {\r\n    padding: 15px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/wave-control-popups/assign-driver-popup/assign-driver-popup.component.css
// module id = ../../../../../src/app/shared/lookup/wave-control-popups/assign-driver-popup/assign-driver-popup.component.css
// module chunks = main